{
  "mode": {
    "fly": "Fly",
    "hike": "Hike"
  },
  "settings": {
    "mode": "Mode",
    "glideRatio": "Glide ratio",
    "decreaseGlideRatio": "Decrease glide ratio",
    "increaseGlideRatio": "Increase glide ratio",
    "clearance": "Terrain clearance, {{unit}}"
  },
  "noResult": {
    "fly": "No reachable landing zones from this takeoff at glide ratio {{gr}}: the terrain around it is not steep enough to glide away. Try a steeper spot.",
    "hike": "No takeoff spots can reach this landing zone at glide ratio {{gr}}: no terrain around it is high enough. Try another landing."
  },
  "originAction": {
    "fly": "Take off here",
    "hike": "Land here"
  },
  "label": {
    "margin": {
      "fly": "<b>{{margin}}</b> AGL",
      "hike": "<b>{{margin}}</b> above LZ"
    }
  }
}
